export let Colors;

(function (Colors) {
  Colors["RED"] = "#F53F3F";
  Colors["ORANGERED"] = "#FF5722";
  Colors["ORANGE"] = "#FF7D00";
  Colors["YELLOW"] = "#FFB400";
  Colors["CYAN"] = "#0FC6C2";
  Colors["GREEN"] = "#00B42A";
  Colors["LIME"] = "#7BC616";
  Colors["ARCOBLUE"] = "#168CFF";
  Colors["BLUE"] = "#165DFF";
  Colors["PURPLE"] = "#7816FF";
  Colors["PINKPURPLE"] = "#B71DE8";
  Colors["MAGENTA"] = "#EB0AA4";
  Colors["GRAY"] = "#86909C";
})(Colors || (Colors = {}));